import React from 'react';
import WistiaVideo from 'components/WistiaVideo';

const RichTextVideo = ({ fields, ...otherProps }) => {
  const videoUrl = fields?.sharableLink && fields?.sharableLink['en-US'];
  const size = fields?.size && fields?.size['en-US'];
  const inline = fields?.playVideoInline?.['en-US'];
  const thumbnail =
    fields?.videoPreviewImage &&
    fields?.videoPreviewImage['en-US'].fields?.image &&
    fields?.videoPreviewImage['en-US'].fields?.image['en-US'].fields?.file &&
    fields?.videoPreviewImage['en-US'].fields?.image['en-US'].fields?.file['en-US'] &&
    fields?.videoPreviewImage['en-US'].fields?.image['en-US'].fields?.file['en-US'].url;

  return (
    <WistiaVideo
      url={videoUrl}
      wrapperStyles={{ margin: '40px auto' }}
      size={size || 'Medium'}
      inline={inline}
      thumbnail={thumbnail}
      {...otherProps}
    />
  );
};

export default RichTextVideo;
